import { orchestrator } from "satcheljs";

import { loadPlacesFailed } from "places-explore-operations";
import { addServiceCallsCompleted } from "../store";

orchestrator(loadPlacesFailed, () => {
    addServiceCallsCompleted("all", false);
});
